import { jwtDecode } from 'jwt-decode';

export interface Token {
  token: string;
}

export class HomeleiteToken implements Token {
  public token: string;
  constructor(
    public authenticatedId: string,
    public tenantId: string,
    public created: Date
  ) {}

  static decode(token: string): HomeleiteToken {
    if (!token) {
      return null;
    }
    const decodedToken = jwtDecode<HomeleiteToken>(token);
    decodedToken.token = token;
    return decodedToken;
  }
}
